export const WEBLATE_COMPONENT_NAME = 'website-pro/wsp-admin-center-client';
